const initialState = {
  allMasterData: {},
  dynamicForm: {},
  subcategories: [],
  isDataFetched: false
};

const MasterDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_MASTER_DATA':
      return { ...state, allMasterData: action.payload };
    case 'GET_SUBCATEGORIES':
      return { ...state, subcategories: action.payload };
    case 'GET_ORDER_MASTER_DATA':
      return { ...state, orderMasterData: action.payload };
    case 'GET_DYNAMIC_FORM':
      return { ...state, dynamicForm: action.payload };
    case 'IS_DATA_FETCHED':
      return { ...state, isDataFetched: action.payload };
    default:
      return state;
  }
};

export default MasterDataReducer;
